export default {
  frontpage: 'Frontpage',
  category: 'CategoryFP',
  article: 'Article',
  'issue-article': 'Article',
  articleComments: 'Comments',
  other: 'Other',
} as Record<string, string>;
